export const setAuthData = (token, user) => ({
    type: 'SET_AUTH_DATA',
    payload: { token, user },
});

export const clearAuthData = () => ({
    type: 'CLEAR_AUTH_DATA',
});